import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AdLayout from '../components/AdLayout';
import NewTthReconciliation from './NewTthReconciliation';
import TthInvoices from './TthInvoices';

/**
 * Màn "Đối soát TTH" — 2 tab (không có tab "Lịch sử đối soát" file cũ, TTH không có flow đó),
 * clone cấu trúc ReconciliationManagement.jsx (luồng Normal).
 */
function TthReconciliationManagement() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'new';
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <AdLayout>
      <div className="table-responsive web-table">
        <div className="tab-container">
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className={`nav-link ${activeTab === 'new' ? 'active' : ''}`} onClick={() => handleTabChange('new')}>
                Tạo đối soát TTH
              </button>
              <button className={`nav-link ${activeTab === 'done' ? 'active' : ''}`} onClick={() => handleTabChange('done')}>
                Danh sách TTH đã đối soát
              </button>
            </div>
          </nav>
          <div className="tab-content bg-white" id="nav-tabContent">
            <div className="tab-pane fade show active" role="tabpanel">
              {activeTab === 'new' && <NewTthReconciliation />}
              {activeTab === 'done' && <TthInvoices embedded={true} />}
            </div>
          </div>
        </div>
      </div>
    </AdLayout>
  );
}

export default TthReconciliationManagement;
